import OrderHistory, {
    DELIVERY_METHOD_DELIVER_CHARTER,
    DELIVERY_METHOD_DELIVER_OWN,
    DELIVERY_METHOD_DELIVER_SAGAWA,
    DELIVERY_METHOD_DELIVER_YAMATO,
    DELIVERY_METHOD_TYPE_LIST,
    DELIVERY_TIME_DETAIL_LIST,
    DELIVERY_TIME_DETAIL_LIST_CHARTER,
    DELIVERY_TIME_DETAIL_LIST_RECEIVER,
    DELIVERY_TIME_DETAIL_LIST_YAMATO,
    DELIVERY_TIME_SPECIFIED_FALSE,
    DELIVERY_TIME_SPECIFIED_TRUE,
    DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF,
    RETURN_METHOD_DELIVER_CHARTER,
    RETURN_TIME_DETAIL_LIST,
    RETURN_TIME_DETAIL_LIST_CHARTER,
    RETURN_TIME_DETAIL_LIST_RECEIVER,
    RETURN_TIME_SPECIFIED_TRUE,
    RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF, USAGE_NAME_EVENT,
    USAGE_NAME_OTHER, USAGE_NAME_PARTY, USAGE_NAME_SHOOTING,
    USAGE_NAME_WEDDING,
} from '../models/OrderHistory'
import moment from 'moment'
import OrderConstant from '../const/OrderConstant'

const DELIVER = 'deliver'
const RECEIVER = 'receiver'

class CheckoutService {
    constructor() {}

    // ご利用詳細フォーム表示
    isShowUsageDetailForm(usageName) {
        return true
        // if (usageName == USAGE_NAME_WEDDING || usageName == USAGE_NAME_OTHER) {
        //     return true
        // }
        // return false
    }

    // ご利用詳細タイトル取得
    getUsageDetailFormLabel(usageName) {
        if (usageName == USAGE_NAME_WEDDING) {
            return 'ご両家名'
        }
        if (usageName == USAGE_NAME_OTHER) {
            return '詳細'
        }
        if (usageName == USAGE_NAME_SHOOTING || 
            usageName == USAGE_NAME_EVENT ||
            usageName == USAGE_NAME_PARTY
        ) {
            return '案件名'
        }
        return ''
    }

    // 納品　宅配or店舗受け取りの予定時間フォーム表示
    isShowDeliveryTimeSpecifiedForm(deliveryMethod) {
        // チャーター便の時は時間指定ができる
        if (deliveryMethod === DELIVERY_METHOD_DELIVER_CHARTER) {
            return {
                isDeliveryTimeDetailForm: false,
                isDeliveryTimeSpecifiedForm: true,
            }
        }
        // 店舗受け取りの時に時間指定希望有無のフォームを表示
        if (this.isMethodTypeReceiver(deliveryMethod)) {
            return {
                isDeliveryTimeDetailForm: true,
                isDeliveryTimeSpecifiedForm: false,
            }
        }
        return {
            isDeliveryTimeDetailForm: false,
            isDeliveryTimeSpecifiedForm: false,
        }
    }

    // 返却　宅配or店舗返却の予定時間フォーム表示
    isShowReturnTimeSpecifiedForm(returnMethod) {
        return this.isMethodTypeReceiver(returnMethod)
    }

    // 時間指定希望有無の予定時間フォーム表示
    isShowDeliveryTimeDetailForm(value) {
        // 指定あり
        if (value === DELIVERY_TIME_SPECIFIED_TRUE) {
            return true
        }
        // 指定あり(引取り)
        if (value === DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF) {
            return true
        }
        // 指定なし
        return false
    }

    // 時間指定希望有無の予定時間フォーム表示
    isShowReturnTimeDetailForm(value) {
        // 指定あり(引取り)
        if (value === RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF) {
            return true
        }
        // 指定なし
        return false
    }

    // 計算
    async calculation(orderHistory, isAutoOff = false) {
        const { data } = await orderHistory.post(`/api/order/calculation?isAutoOff=${isAutoOff}`)
        return data
    }

    // 2週間以降でないとアラート
    isUsageDateAlert(usageDate) {
        const limit = moment().add(14, 'days').format('YYYY-MM-DD')
        const target = moment(usageDate).format('YYYY-MM-DD')
        if (target < limit) {
            return '発注期限(納品日の2週間前)後の発注のため、ご対応が難しい場合がございます。\n'
        }
    }

    // 7日以降でないとアラート
    isDeliveryDateAlert(deliveryDate) {
        const limit = moment().add(7, 'days').format('YYYY-MM-DD')
        const target = moment(deliveryDate).format('YYYY-MM-DD')
        if (target < limit) {
            return '発注期限(納品日の2週間前)後の発注のため、ご対応が難しい場合がございます。\n'
        }
    }

    // 5日間（4泊5日）の間じゃない時にアラート
    isReturnDateAlert(deliveryDate, returnDate) {
        if (deliveryDate && returnDate) {
            const d = moment(returnDate).diff(deliveryDate, 'days')
            if (d >= 5) {
                return '表示されているレンタル金額は5日間（4泊5日）となります。\nご希望日数でのレンタル金額は別途見積書にてご案内致します。'
            }
        }
        return ''
    }

    // 店舗受け取りかどうか
    isMethodTypeReceiver(value) {
        if (!value) return false
        const arr = value.split('_')
        return arr[0] === RECEIVER
    }

    // 延長後返却日フォーム表示
    isShowExtendedDateForm(status) {
        const list = [
            OrderConstant.ORDER_STATUS_FIXED,
            OrderConstant.ORDER_STATUS_PAYMENT_WAIT,
            OrderConstant.ORDER_STATUS_DELIVERY_PENDING,
            OrderConstant.ORDER_STATUS_DELIVERY_COMPLETE,
            OrderConstant.ORDER_STATUS_CANCEL,
        ]
        return list.includes(status)
    }

    // ユーザーにメールを送信するかの有無表示
    isShowSendMailCheckForm(status) {
        const list = [
            OrderConstant.ORDER_STATUS_WSG_APPROVAL,
            OrderConstant.ORDER_STATUS_FIXED,
            OrderConstant.ORDER_STATUS_CANCEL,
            OrderConstant.ORDER_STATUS_DELIVERY_PENDING,
            OrderConstant.ORDER_STATUS_COMPLETE,
        ]
        return list.includes(status)
    }

    // 納品方法取得
    getDeliveryMethodOptions(TimeSpecified, isCartInCharterOnly = false) {
        let placeHolder = [{ value: '', name: '選択してください' }]
        if (isCartInCharterOnly) {
            const res = DELIVERY_METHOD_TYPE_LIST.filter(
                (x) => x.value === DELIVERY_METHOD_DELIVER_CHARTER
            )
            return placeHolder.concat(res)
        }
        let arr = DELIVERY_METHOD_TYPE_LIST.map((x) => x.value)
        if (TimeSpecified === DELIVERY_TIME_SPECIFIED_FALSE) {
            arr = [DELIVERY_METHOD_DELIVER_SAGAWA, DELIVERY_METHOD_DELIVER_OWN]
        }
        if (TimeSpecified === DELIVERY_TIME_SPECIFIED_TRUE) {
            arr = [
                DELIVERY_METHOD_DELIVER_YAMATO,
                DELIVERY_METHOD_DELIVER_CHARTER,
                DELIVERY_METHOD_DELIVER_OWN,
            ]
        }
        if (TimeSpecified === DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF) {
            arr = arr.filter((x) => this.isMethodTypeReceiver(x))
        }
        const res = DELIVERY_METHOD_TYPE_LIST.filter((x) => arr.includes(x.value))
        return placeHolder.concat(res)
    }

    // 希望時間オプション取得
    getTimeDetailSelectOptions(methodValue) {
        let placeHolder = [{ value: '', name: '選択してください' }]
        let arr = DELIVERY_TIME_DETAIL_LIST.map((x) => x.value)
        if (methodValue === DELIVERY_METHOD_DELIVER_CHARTER) {
            arr = DELIVERY_TIME_DETAIL_LIST_CHARTER
        }
        if (methodValue === DELIVERY_METHOD_DELIVER_YAMATO) {
            arr = DELIVERY_TIME_DETAIL_LIST_YAMATO
        }
        if (this.isMethodTypeReceiver(methodValue)) {
            arr = DELIVERY_TIME_DETAIL_LIST_RECEIVER
        }
        const res = DELIVERY_TIME_DETAIL_LIST.filter((x) => arr.includes(x.value))
        return placeHolder.concat(res)
    }

    // 返却希望時間オプション取得
    getReturnTimeDetailOptions(methodValue) {
        let placeHolder = [{ value: '', name: '選択してください' }]
        let arr = RETURN_TIME_DETAIL_LIST.map((x) => x.value)
        if (methodValue === RETURN_METHOD_DELIVER_CHARTER) {
            arr = RETURN_TIME_DETAIL_LIST_CHARTER
        }
        if (this.isMethodTypeReceiver(methodValue)) {
            arr = RETURN_TIME_DETAIL_LIST_RECEIVER
        }
        const res = RETURN_TIME_DETAIL_LIST.filter((x) => arr.includes(x.value))
        return placeHolder.concat(res)
    }

    isShowCarriedSupportForm(methodValue) {
        if (!methodValue) return false
        return methodValue === DELIVERY_METHOD_DELIVER_CHARTER
    }
    isShowCarryOutSupportForm(methodValue) {
        if (!methodValue) return false
        return methodValue === RETURN_METHOD_DELIVER_CHARTER
    }
}

export default new CheckoutService()



// WEBPACK FOOTER //
// ./resources/assets/js/services/CheckoutService.js